import { NotifyHelper } from "../../../helpers/toast";
import { objCrmHocSinhDefine } from "../../action-types/crm-hocsinh/ICrmHocSinhActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const crmHocSinhActions = {
    // Tạo các action cơ bản cho HocSinh API
    ...generateActions(objCrmHocSinhDefine, "CRM_HOC_SINH"),

    // Xử lý lỗi khi load dữ liệu
    ...generateActionForKey(objCrmHocSinhDefine, "CRM_HOC_SINH",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),

    // Xử lý thành công khi cập nhật thông tin cố vấn
    ...generateActionForKey(objCrmHocSinhDefine, "CRM_HOC_SINH",
        "UPDATE_ADVISOR_SUCCESS", () => NotifyHelper.Success("Advisor updated successfully")),

    // Xử lý lỗi khi cập nhật thông tin cố vấn
    ...generateActionForKey(objCrmHocSinhDefine, "CRM_HOC_SINH",
        "UPDATE_ADVISOR_ERROR", (m: any) => NotifyHelper.Error(m)),

    // Xử lý thành công khi tìm kiếm học sinh
    ...generateActionForKey(objCrmHocSinhDefine, "CRM_HOC_SINH",
        "SEARCH_SUCCESS", (m: any) => NotifyHelper.Success("Search completed successfully")),

    // Xử lý lỗi khi tìm kiếm học sinh
    ...generateActionForKey(objCrmHocSinhDefine, "CRM_HOC_SINH",
        "SEARCH_ERROR", (m: any) => NotifyHelper.Error(m)),

    // Xử lý thành công khi lấy thông tin chi tiết học sinh
    ...generateActionForKey(objCrmHocSinhDefine, "CRM_HOC_SINH",
        "GET_BY_ID_SUCCESS", (m: any) => NotifyHelper.Success("Student details loaded successfully")),

    // Xử lý lỗi khi lấy thông tin chi tiết học sinh
    ...generateActionForKey(objCrmHocSinhDefine, "CRM_HOC_SINH",
        "GET_BY_ID_ERROR", (m: any) => NotifyHelper.Error(m)),
};
